export default __webpack_public_path__ + "static/media/Logo gold.4c470184.jpg";